<template>
  <div class="" style="margin-left: auto; margin-right: auto;">
     
    <form>
      <div  style="overflow-x: auto; overflow-y: hidden;">
        <div  style="margin: 20px; position: relative; width: 1000px; height: 750px; ">
          <vue-html2pdf ref="html2Pdf" :show-layout="false" :float-layout="false" :enable-download="true"
                        :preview-modal="false" filename="desprendible" :pdf-quality="2" pdf-format="letter"
                        pdf-orientation="landscape" pdf-content-width="1000px" :html-to-pdf-options="HtmlOpciones"
                        style="margin: 0 !important; padding: 0 !important;">
            <section v-if="cursoAcademia.certificadoFinalizacion == 1" slot="pdf-content" style="padding: 0 !important; margin: 0 !important; top: 0">
              <div class="container-cert-pdf " >
                <div class="border   p-2 shadow rounded bg-white bg-certificado-pdf">
                 
                  <div class="logo-container">
                    <img class="logo-helex-sm d-flex ml-auto" src="/img/HXLogoBlack.png" alt="logo_helex"/>
                    <img class="qrCert  d-flex ml-auto" v-if="qrImg" :src="qrImg" alt="QR Code"/>
                  </div>
                  <div class="d-flex flex-column h-100 justify-content-center align-items-center">
                    <div>
                      <img class="logo-helex mb-5 display" :src="certificadoData.Curso.EmpresaLogo" alt="logo"/>
                    </div>
                    <div class="px-5 pt-2 pb-5 text-center">
                      
                      <p class=" title">CERTIFICADO</p>
                      <h2 class="tittle-letter">DE FINALIZACIÓN</h2>
                      <h5 class="mt-3 subtittle-letter">Este certificado se otorga a:</h5>
                      <p class="pb-0 mb-0 name py-2">{{ certificadoData.Persona.nombreEstudiante }}</p>
                      <div style="font-size: 1.4rem; color: rgb(0, 0, 0) !important;">
                        <p>
                          Por haber completado satisfactoriamente el curso: <br/><b>
                          {{ certificadoData.Curso.CursoTitulo }}</b>
                        </p>
                        <p>
                          Impartido por:<br/><b>{{ certificadoData.Curso.CursoResponsableNombreCompleto }}</b>
                        </p>
                        <p class="text-center pt-3">
                          En reconocimiento a su esfuerzo y dedicación durante el curso, otorgamos este certificado como
                          testimonio de su logro y compromiso con el aprendizaje.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section v-if="cursoAcademia.certificadoFinalizacion == 3" slot="pdf-content" style="padding: 0 !important; margin: 0 !important; top: 0">
              <div class="container-cert-pdf " >
                <div class="border   p-2 shadow rounded bg-white bg-certificado-pdf-3">
                 
                  <div class="logo-container">
                    <img class="logo-oma-sm d-flex ml-auto mr-1" src="/img/mesofoodsIcon.png" alt="logo"/>
                    <!-- <img class="qrCert  d-flex ml-auto mr-3" v-if="qrImg" :src="qrImg" alt="QR Code"/> -->
                  </div>
                  <div class="d-flex flex-column h-100 justify-content-center align-items-center">
                    <div>
                      <img class="logo-omav2   display" src="/img/mesofoodsv2.png" alt="logo"/>
                      <!-- <img class="logo-helex mb-5 display" :src="certificadoData.Curso.EmpresaLogo" alt="logo"/> -->
                    </div>
                    <div class="px-5   pb-5 text-center">
                      
                      <h2 class=" tittle-letter">Certifica que</h2>
                      <!-- <h2 class="tittle-letter">DE FINALIZACIÓN</h2> -->
                      <!-- <h5 class="mt-3 subtittle-letter">Este certificado se otorga a:</h5> -->
                      <p class="pb-0 mb-0 name py-2">
                        <span
                        class="px-3"
                        style="
                          border-bottom: 2px solid #e4191f;
                          display: inline-block;
                          line-height: 1;
                          padding-bottom: 1px;
                          margin-bottom: -5px;
                        ">
                          {{ certificadoData.Persona.nombreEstudiante }}
                        </span>
                      </p>  
                      <div style="font-size: 1.4rem; color: rgb(0, 0, 0) !important;">
                        <p>
                          Ha realizado su y superado con éxito el curso <br/><br>
                          <b class=" ">{{ certificadoData.Curso.CursoTitulo }}</b>
                        </p>
                        <!-- <p>
                          Impartido por:<br/><b>{{ certificadoData.Curso.CursoResponsableNombreCompleto }}</b>
                        </p> -->
                        <p class="text-center pt-3 w-75 mx-auto">
                          Adquirió con responsabilidad los conocimientos para la excelente ejecución del proceso, en el que el producto es el protagonista.
                          <!-- <br><br><b>“Bienvenidos Al Lugar Donde Somos Uno Para Cada Uno”</b> -->
                        </p>
                        <div class="mt-auto pt-3 text-center" style="margin-top: auto !important;">
                          <div class="d-flex justify-content-center w-100 mx-auto">
                            <img class="logo-omaPAHS py-1 display mx-2" src="/img/firmas-cert-oma-1.png" alt="logo"/>
                            <img class="logo-omaPAHS py-1 display mx-2" src="/img/firmas-cert-oma-2.png" alt="logo"/>
                          </div>
                          <img class="logo-omaPAHS-2 py-1 mt-2" src="/img/mesofoodsPAHS.png" alt="logo"/>
                        </div>
                        <!-- <diV class="d-flex mt-3 justify-content-center"> 
                          <div class="d-flex justify-content-between w-75">
                            <img class="logo-omaPAHS py-1 display" src="/img/firmas-cert-oma-1.png" alt="logo"/>
                            <img class="logo-omaPAHS py-1 display" src="/img/firmas-cert-oma-2.png" alt="logo"/>
                          </div>
                        </div>
                        <img class="logo-omaPAHS-2 py-1 " src="/img/mesofoodsPAHS.png" alt="logo"/> -->
                        <!-- <p class="pb-0 mb-0   py-2">
                        <span style="
                          border-bottom: 2px solid rgb(255, 5, 63);
                          display: inline-block;
                          line-height: 1;
                          padding-bottom: 1px;
                          margin-bottom: -5px;
                        ">
                          <b class="px-3">Entrenamiento</b>
                        </span>
                      </p>   -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section v-if="cursoAcademia.certificadoFinalizacion == 4" slot="pdf-content" style="padding: 0 !important; margin: 0 !important; top: 0">
              <div class="container-cert-pdf " >
                <div class="border   p-2 shadow rounded bg-white bg-certificado-pdf-2">
                 
                  <div class="logo-container">
                    <img class="logo-oma-sm d-flex ml-auto mr-1" src="/img/mesofoodsIcon.png" alt="logo"/>
                    <!-- <img class="qrCert  d-flex ml-auto" v-if="qrImg" :src="qrImg" alt="QR Code"/> -->
                  </div>
                  <div class="d-flex flex-column h-100 justify-content-center align-items-center">
                    <div>
                      <img class="logo-oma   display" src="/img/mesofoods.png" alt="logo"/>
                      <!-- <img class="logo-helex mb-5 display" :src="certificadoData.Curso.EmpresaLogo" alt="logo"/> -->
                    </div>
                    <div class="px-5   pb-5 text-center">
                      
                      <h2 class=" tittle-letter">Certifica que</h2>
                      <!-- <h2 class="tittle-letter">DE FINALIZACIÓN</h2> -->
                      <!-- <h5 class="mt-3 subtittle-letter">Este certificado se otorga a:</h5> -->
                      <p class="pb-0 mb-0 name py-2">
                        <span style="
                          border-bottom: 2px solid rgb(255, 5, 63);
                          display: inline-block;
                          line-height: 1;
                          padding-bottom: 1px;
                          margin-bottom: -5px;
                        ">
                          {{ certificadoData.Persona.nombreEstudiante }}
                        </span>
                      </p>  
                      <div style="font-size: 1.4rem; color: rgb(0, 0, 0) !important;">
                        <p>
                          Ha realizado su y superado con éxito el curso <br/><br>
                          <b class=" ">{{ certificadoData.Curso.CursoTitulo }}</b>
                        </p>
                        <!-- <p>
                          Impartido por:<br/><b>{{ certificadoData.Curso.CursoResponsableNombreCompleto }}</b>
                        </p> -->
                        <p class="text-center pt-3 w-75 mx-auto">
                          Adquiriendo los conocimientos para la excelente ejecución del proceso, en el que el producto hace parte de la experiencia.
                          <br><br><b>“Bienvenidos Al Lugar Donde Somos Uno Para Cada Uno”</b>
                        </p>
                        <img class="logo-omaPAHS py-1 display" src="/img/mesofoodsPAHS.png" alt="logo"/>
                        <p class="pb-0 mb-0   py-2">
                        <span style="
                          border-bottom: 2px solid rgb(255, 5, 63);
                          display: inline-block;
                          line-height: 1;
                          padding-bottom: 1px;
                          margin-bottom: -5px;
                        ">
                          <b class="px-3">Entrenamiento</b>
                        </span>
                      </p>  
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </vue-html2pdf>
        </div>
      </div>
      
    </form>
  </div>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf";
import Swal from "sweetalert2";
export default {
  components: {
    VueHtml2pdf,
  },
  data() {
    return {
      cursoAcademia: null,
      qrImg: '',
      imgBase64: null,
      certificadoData: {},
      IdEstudiante: null,
      IdCurso: null,
      curso: {},
      persona: {},
      empresaId: null,
      selectedOption: 'opcion1',
      HtmlOpciones: {
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        enableLinks: false,
        html2canvas: {
          scale: 1,
          useCORS: true,
        },
        jsPDF: {
          unit: "mm",
          format: "letter",
          orientation: "landscape",
        },
      },
    }
  },
  created() {
    // console.log("Parámetros en la ruta:", this.$route.params);
    this.IdCurso = this.$route.params.CursoId;
    this.IdEstudiante = this.$route.params.PersonaId;
  },
  async mounted() {
    try {
      this.getListClasesCursoAcademia()

      // this.IdCurso = this.$route.params.id;
      // this.IdEstudiante = this.$route.params.IdEstudiante;
      await this.getData()
      await this.generarQR()
      this.imgBase64 = await this.convertirImagen(this.certificadoData.Curso.EmpresaLogo)

      this.persona = JSON.parse(localStorage.getItem("setPersonaAct"));
      this.empresaId = this.persona.empresa.id;

    } catch (error) {
      console.log('error en mounted', error)
    }
  },
  methods: {
    async getListClasesCursoAcademia() {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: `ClasesCursosAcademia/ObtenerInformacionCurso/${this.IdCurso}/persona/${this.IdEstudiante}`,
        });
        if (res.respuesta) {
          this.cursoAcademia = res.data;
          // this.listaClases = res.data.Clases;
           
        }
      } catch (error) {
        console.log("error capturado: ", error);
      }
    },
    async generarQR() {
      const datos = `https://helexiumfiles.com/CertificadoQR/${this.IdCurso}/${this.IdEstudiante}`;


      const apiEndpoint = "https://api.qrserver.com/v1/create-qr-code/";
      const queryParams = `?data=${encodeURIComponent(datos)}&size=200x200`;
      let qrUrl = `${apiEndpoint}${queryParams}`;

      try {
        const response = await fetch(qrUrl);
        const blob = await response.blob();

        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          this.qrImg = reader.result; // Guardamos la imagen en base64
          console.log('QR en base64:', this.qrImg);
        };
      } catch (error) {
        console.error("Error al generar el QR:", error);
      }
    },
    async convertirImagen(url) {
      try {
        const response = await fetch(url);  // Obtener la imagen desde la URL
        const blob = await response.blob();  // Convertir la respuesta en un Blob
        const mimeType = blob.type;  // Obtener el tipo MIME de la imagen

        console.log("Tipo MIME detectado:", mimeType);  // Verifica el tipo MIME recibido

        // Verifica si el tipo MIME es una imagen válida
        if (!mimeType.startsWith('image/')) {
          throw new Error('El archivo no es una imagen válida');
        }

        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);  // Leer el Blob como Data URL (Base64)
          reader.onload = () => {
            let base64Data = reader.result;

            // Asegurarse de que el prefijo MIME sea el correcto
            if (base64Data.startsWith("data:application/octet-stream")) {
              base64Data = base64Data.replace(
                  "data:application/octet-stream",
                  `data:${mimeType}`
              );
            }

            resolve(base64Data);  // Regresa la cadena Base64 con el tipo MIME correcto
          };
          reader.onerror = (error) => reject(error);  // Manejar errores de la conversión
        });
      } catch (error) {
        console.error("Error al convertir la imagen:", error);
        return "";
      }
    },

    async getData() {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "CursosAcademia/ObtenerCursoEmpresa/" + this.IdCurso + '/' + this.IdEstudiante
        });
        if (res.respuesta) {
          this.certificadoData = res.data;
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: res.mensaje,
          }).then(() => {
            this.$router.push(`/helex/Ayuda/Academia/AcademiaVideos/${this.IdCurso}`);
          });
        }

      } catch (err) {
        console.log('error en obtener certificado-->', err)
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    toPdf() {
      //html2pdf(document.getElementById('exportpdf'));
      //this.$refs.html2Pdf.generatePdf();
      this.$refs.html2Pdf.generatePdf();
    },
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Dancing+Script:wght@700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Parisienne&display=swap");
.logo-oma {
  width: 30rem;
  max-width: 50rem;
 
}
.logo-omav2 {
  width: 30rem;
  max-width: 50rem;
   margin-top: 25px !important;

 
}
.logo-omaPAHS {
  width: 13rem;
  max-width: 70rem;
 
}
.logo-omaPAHS-2 {
  width: 15rem;
  max-width: 70rem;
 
}

.logo-oma-sm {
  width: 6rem;
  /* opacity: 0.9; */
}
.qrCert {
  margin-top: 1rem;

  margin-left: auto !important;
  width: 55%;
  height: 55%;
  /* width: 5rem;
  height: 5rem; */
}

.container-cert-pdf {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 !important;
  padding: 0 !important;
}

/* Logo en la esquina */
.logo-container {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 10;
}

/* Logo en la esquina */
.logo-container {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 10;
}

.logo-helex {
  width: 10rem;
  max-width: 12rem;
  opacity: 0.9;
}

.logo-helex-sm {
  width: 8rem;
  opacity: 0.9;
}

/* Estilos del certificado */
.tittle-letter, .subtittle-letter, p {
  font-family: "Times New Roman", Times, serif;
  color: rgb(42, 42, 42) !important;
}

.subtittle-letter {
  letter-spacing: 2px !important;
  color: rgb(42, 42, 42) !important;

}

.title {
  color: rgb(13, 13, 13) !important;
  font-size: 3.8rem;
  font-weight: bold;
  letter-spacing: 2px !important;
}

.name {
  color: rgb(0, 0, 0) !important;
  font-size: 3.8rem;
  font-family: "Parisienne", serif;
  font-weight: 400;
  font-style: normal;
}

.bg-certificado-pdf {
  break-inside: avoid;
  background-image: url("/img/bg-cert.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  top: 0;
  left: 0;
  width: 1060px;
  height: 815px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  transform-origin: center;
}
.bg-certificado-pdf-2 {
  break-inside: avoid;
  background-image: url("/img/bg-cert-oma.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 0;
  left: 0;
  width: 1060px;
  height: 815px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  transform-origin: center;
}
.bg-certificado-pdf-3 {
  break-inside: avoid;
  background-image: url("/img/bg-cert-oma-presto.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 0;
  left: 0;
  width: 1060px;
  height: 815px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  transform-origin: center;
}
</style>